import lists from "./lists.json";
console.log(lists);
export default lists;
    